import { Jsonld } from "../../jsonld";
import { getOfferSchema } from "../offer";
import type { OfferCatalogSchemaProps, OfferCatalog } from "./offer-catalog.types";

export function OfferCatalogSchema(
  data: Readonly<OfferCatalogSchemaProps>
): JSX.Element | null {
  if (!data.items?.length) return null;
  const schemaTypeId = "jsonld_offercatalog_rb";
  const json = {
    "@context": "https://schema.org",
    "@type": "OfferCatalog",
    ...(data.name && { name: data.name }),
    ...(data.description && { description: data.description }),
    ...(data.url && { url: data.url }),
    ...(typeof data.numberOfItems === "number" && { numberOfItems: data.numberOfItems }),
    itemListElement: data.items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Vehicle",
        ...(item.name && { name: item.name }),
        ...(item.image?.length && { image: item.image }),
        ...(item.offers && { offers: getOfferSchema(item.offers) }),
      },
    })),
  } as const satisfies OfferCatalog;

  return (
    <Jsonld id={schemaTypeId} dataSchema={json} dataQa={schemaTypeId} />
  );
}